const prodCaptcha = "6LdF2H0oAAAAAO0YXBHwTHkaU1FjTK5Y55AvchBW";
const devCaptcha = process.env.RECAPTCHA_PUBLIC_KEY;

export const captchaKey = devCaptcha !== undefined ? devCaptcha : prodCaptcha;